// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1995":"170b1de4e09f5836","4645":"f8d8f54929018d12","5036":"c0c829b06abcba1a","7063":"f889d93384c616b9"}[chunkId] + ".js";
};